import { isTextSelection } from "@tiptap/react";

const VALID_BLOCK_TYPES = new Set([
  "paragraph",
  "heading",
  "bulletList",
  "orderedList",
  "listItem",
  "blockquote",
]);

const selectionHasValidBlock = (selection: any) => {
  let hasValidBlock = false;
  selection.content().content.descendants((node: any) => {
    if (VALID_BLOCK_TYPES.has(node.type.name)) {
      hasValidBlock = true;
      return false;
    }
    return true;
  });
  if (!hasValidBlock) {
    hasValidBlock = VALID_BLOCK_TYPES.has(selection.$from.node().type.name);
  }
  return hasValidBlock;
};

export const shouldShowToolbar = ({ editor, view, state, from, to }: any) => {
  const { doc, selection } = state;

  if (!view.hasFocus() || !isTextSelection(selection) || selection.empty) {
    return false;
  }

  if (editor.$node("aicopilot")) {
    return false;
  }

  return (
    Boolean(doc.textBetween(from, to).length) &&
    selectionHasValidBlock(selection)
  );
};
